import React from 'react';
import DialogComponent from '@ui/components/Dialog/Dialog.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    onConfirmClick,
    onCancelClick,
}: IProps) => {
    return (
        <>
            <DialogComponent
                className="close-device-settings"
                title="confirmSettingsClose"
                lang={lang}
                onConfirmClick={onConfirmClick}
                onCancelClick={onCancelClick}
            />
        </>
    );
};

const CloseDeviceSettingsComponent = React.memo(Component);

export default CloseDeviceSettingsComponent;
